import { useEffect } from "react";
import AsyncSelect from "react-select/async";
import { Col } from "reactstrap";

export type SelectItemsProps = {
    label: string;
    value: string;
};

export type Select2ComponentProps = {
    label: string;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    loadOptions: (value: string) => Promise<SelectItemsProps[]>;
    onChange: (value: SelectItemsProps) => void;
    value: SelectItemsProps | undefined | null;
    isDisabled?: boolean;
    style?: React.CSSProperties;
    required?: boolean;
};

export default function SearchSelectComponent(props: Select2ComponentProps) {

    const handleInputChange = (inputValue: any) => {
        props.onChange(inputValue);
    };

    useEffect(() => {
        if (props.value?.value === "") {
            handleInputChange("");
        }
    }, [props.value]);

    return (
        <Col
            xl={props.xl}
            lg={props.lg}
            md={props.md}
            sm={props.sm}
            xs={props.xs}
            style={{ margin: "6.4px 0px" }}
        >
             <span className="label">
                {props.label}
                {props.required && <span style={{ marginRight: 2, fontSize: '14px' }}>*</span>}
                :
            </span>
            
            <div>
                <AsyncSelect
                    isDisabled={props.isDisabled}
                    value={props.value}
                    defaultOptions={false}
                    cacheOptions={false}
                    placeholder={"Não Selecionado"}
                    loadOptions={props.loadOptions}
                    onChange={handleInputChange}
                    noOptionsMessage={() => "Comece a escrever para pesquisar"}
                    loadingMessage={() => "A Carregar..."}
                    isClearable={true}
                    styles={{
                        control: (base: any) => ({
                            ...base,
                            minHeight: 38,
                            fontSize: 13,
                        }),
                    }}
                    theme={(theme: any) => ({
                        ...theme,
                        borderRadius: 10,
                        colors: {
                            ...theme.colors,
                            primary: "black",
                        },
                    })}
                />
            </div>
        </Col>
    );
}
